/**
 * @generated SignedSource<<abc1ab108968dc6aafb439c3a7cafeb5>>
 * @relayHash 27ed85c78d28b8688dae45c430686d13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a352ca5097b61df2de7142d122467efb0957902bd707578ad66a6515a13c3cce

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GrowthUnifiedProfileProductEdition = "ENTERPRISE" | "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type freeChooseYourEditionModalQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type freeChooseYourEditionModalQuery$data = {
  readonly confluence_storage: {
    readonly bytesLimit: AGG$Long | null | undefined;
    readonly bytesUsed: AGG$Long;
    readonly isUnlimited: boolean | null | undefined;
  } | null | undefined;
  readonly growthUnifiedProfile_getUnifiedProfile: {
    readonly sites: ReadonlyArray<{
      readonly products: ReadonlyArray<{
        readonly nbeRecommendation: {
          readonly edition: GrowthUnifiedProfileProductEdition | null | undefined;
        } | null | undefined;
        readonly productName: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingPremium: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type freeChooseYourEditionModalQuery = {
  response: freeChooseYourEditionModalQuery$data;
  variables: freeChooseYourEditionModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Premium"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v5 = {
  "concreteType": "ConfluenceStorage",
  "kind": "LinkedField",
  "name": "confluence_storage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isUnlimited"
    },
    {
      "kind": "ScalarField",
      "name": "bytesUsed"
    },
    {
      "kind": "ScalarField",
      "name": "bytesLimit"
    }
  ]
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "cloudId"
    }
  ],
  "concreteType": "GrowthUnifiedProfileResult",
  "kind": "LinkedField",
  "name": "growthUnifiedProfile_getUnifiedProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileSiteDetails",
      "kind": "LinkedField",
      "name": "sites",
      "plural": true,
      "selections": [
        {
          "concreteType": "GrowthUnifiedProfileProductDetails",
          "kind": "LinkedField",
          "name": "products",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "productName"
            },
            {
              "concreteType": "GrowthUnifiedProfileProductNBE",
              "kind": "LinkedField",
              "name": "nbeRecommendation",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "edition"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "freeChooseYourEditionModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "changeOfferingPremium",
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "freeChooseYourEditionModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": "changeOfferingPremium",
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      },
      (v5/*: any*/),
      (v6/*: any*/)
    ]
  },
  "params": {
    "id": "a352ca5097b61df2de7142d122467efb0957902bd707578ad66a6515a13c3cce",
    "metadata": {},
    "name": "freeChooseYourEditionModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3cdbba3047dddd61d21742843e110fa5";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
